<template>
  <span class="star" v-on="getStar()">
    <span v-if="starFlag" class="material-icons-round star star-color" @click="deleteStar">star</span>
    <span v-else class="material-icons-round star" @click="addStar" v-tooltip="{content: hoverMsg, trigger:'hover'}">star_border</span>
  </span>
</template>

<script>
import { userService } from '@/services/user.service'

export default {
  props: ['position'],
  name: 'Star',
  data () {
    return {
      starFlag: false,
      hoverMsg: this.$t('star.hover.star')
    }
  },
  methods: {
    getStar: function () {
      userService.getStar(this.$route.params.projectId).then(star => {
        //console.info('Get star: ', star)
        if(star){
          this.starFlag = true
        } else {
          this.starFlag = false
        }
      }).catch(err => {
        console.error('Unable to get star: ', err)
      })
    },
    addStar: function () {
      userService.addStar(this.$route.params.projectId).then(() => {
        this.starFlag = true
        this.showToast(this.$t('star.toast.addStar'))
        //console.info('Add star: ', star)
      }).catch(err => {
        console.error('Unable to add star: ', err)
      })
    },
    deleteStar: function () {
      userService.deleteStar(this.$route.params.projectId).then(() => {
        this.starFlag = false
        this.showToast(this.$t('star.toast.deleteStar'))
        //console.info('Delete star: ', star)
      }).catch(err => {
        console.error('Unable to delete star: ', err)
      })
    },
    showToast: function (msg) {
      this.$toasted.show(msg, {
        type: 'info',
        duration: 5000,
        theme: 'bubble',
        position: this.position,
        icon: {
          name: 'check_circle_outline'
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.star {
  cursor: pointer;
}

.star-color {
  color: $star-alpha;
}
</style>
